import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetDefaultUserOrg = () => {
    const { zoneApiClient, zoneGuid } = useZoneContext();
    return useQuery({
        queryKey: [`get-default-user-org-${zoneGuid}`],
        queryFn: async () => {
            const response = await zoneApiClient.getCurrentUserOrganizationFromServer(zoneGuid);

            if (!response) return;

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve default user org.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        enabled: zoneGuid !== ''
    });
};
